import { IRawStyle, IStyle, mergeStyles } from "@uifabric/merge-styles";
import React from "react";

export const SpanningBar = ({extendedStyle, children} : {extendedStyle?: IRawStyle, children: JSX.Element | JSX.Element[]}) => {
	let stm: IStyle = {
		position: 'static',
		textAlign: 'center',
		padding: 6,
		background: '#fff',
		boxShadow: '0px 0px 4px 4px rgba(0, 0, 0, 0.025)',
	}

    if (extendedStyle) {
        stm = {...stm, ...extendedStyle}
    }
    
    const style = mergeStyles(stm)

	return (
		<div className={style}>
			{children}
		</div>
	)
}